export default {
  backHome: "← Back to Home",
  articleNotFound: "Guide not found.",
  moreGuides: "Explore more original buying guides on the AllChinaBuy spreadsheet.",
  browseGuides: "Browse All Guides",
  published: "Published",
  updated: "Last updated",
  author: "By the AllChinaBuy Spreadsheet Team",
  readTime: "min read",

  title: "AllChinaBuy Spreadsheet: The Complete Buyer Guide",
  metaTitle: "AllChinaBuy Spreadsheet: The Complete Buyer Guide (2026)",
  metaDescription: "A complete guide to the AllChinaBuy spreadsheet — how to find products, evaluate sellers, read QC photos and choose shipping. Original, buyer-focused tips for smarter shopping.",

  intro: "The AllChinaBuy spreadsheet has become a popular way for buyers to organize product finds, compare sellers and track quality checks before placing an order. This guide explains what the spreadsheet is, how to use it, and how to avoid the most common mistakes — so you can shop with better information and less guesswork.",

  tocTitle: "Table of Contents",

  sections: [
    {
      id: "what-is",
      heading: "What Is the AllChinaBuy Spreadsheet?",
      body: [
        "The AllChinaBuy spreadsheet is a structured document that collects product links, seller details, quality-check (QC) notes and shipping information into a single view. Instead of keeping dozens of browser tabs open, buyers use the spreadsheet to compare items side by side and spot the most reliable options.",
        "A typical AllChinaBuy spreadsheet groups items by category — shoes, hoodies, t-shirts, jackets, bags, accessories and more — then adds columns for QC status, seller reliability, useful notes and the last-updated date. This structure turns a messy list of links into a clear, filterable resource.",
      ],
    },
    {
      id: "how-to-use",
      heading: "How to Use the Spreadsheet",
      body: [
        "Start by picking a category you are interested in, then scan the rows for items that match your taste and budget. Pay attention to the QC column — items marked as verified usually come with confirmed photos and dimensions, while unmarked items need extra research before you commit.",
        "Use the seller column to check whether a seller has consistent, reliable listings. The last-updated date matters too: information changes quickly, so prioritize rows that were refreshed recently.",
      ],
    },
    {
      id: "evaluate-sellers",
      heading: "How to Evaluate Sellers",
      body: [
        "A good seller tends to have detailed product photos, accurate sizing charts and a history of consistent listings. When comparing sellers in the AllChinaBuy spreadsheet, look for those with clear QC information and fewer complaints about sizing or material differences.",
        "Do not rely on a single listing. Cross-check the same product across categories when possible, and treat missing information as a signal to ask questions rather than a reason to skip the item entirely.",
      ],
    },
    {
      id: "qc-photos",
      heading: "Reading QC Photos",
      body: [
        "QC photos are your best defense against surprises. Look for images that show the actual product, not just studio renders — check stitching, logos, tags, color accuracy and measurements. A helpful QC set includes close-ups of details that are easy to get wrong.",
        "When reviewing QC photos in the context of the AllChinaBuy spreadsheet, compare them against the original listing. If something looks different, request clarification before shipping.",
      ],
    },
    {
      id: "shipping",
      heading: "Shipping and Costs",
      body: [
        "International shipping cost depends on destination, package weight and the shipping line you choose. Heavier items like jackets and shoes cost more to ship, while lightweight accessories and t-shirts are cheaper. Use the shipping guides in the spreadsheet to estimate costs before you order.",
        "Delivery time varies by carrier and destination. Faster lines cost more but arrive sooner; economy lines save money but take longer. Choose based on how urgently you need the items and how much you are willing to spend.",
      ],
    },
    {
      id: "mistakes",
      heading: "Common Mistakes to Avoid",
      body: [
        "One of the most common mistakes is ignoring QC information and ordering blind. Another is choosing the wrong size because the sizing chart was skipped. Both are easy to avoid when you use the spreadsheet's notes and QC fields consistently.",
        "Rushing to ship without reviewing the final QC photos is also risky. Take the time to confirm everything looks right — it is far cheaper than discovering a problem after the package has already left the warehouse.",
      ],
    },
  ],

  ctaTitle: "Ready to browse the organized finds?",
  ctaDesc: "Continue to the main website to explore the full AllChinaBuy spreadsheet, organized by category, with QC and seller information.",
  ctaLabel: "Explore AllChinaBuy Spreadsheet",
  buyLabel: "Buy It Now",
  backLabel: "Back to the Resource Center",
};